
import pageTransition from '@/mixins/pageTransition'
import pageProperties from '@/mixins/pageProperties'
import _debounce from 'lodash.debounce'
import _throttle from 'lodash.throttle'

export default {
  props: {
    page: Object,
  },

  mixins: [pageTransition, pageProperties],

  data() {
    return {
      visibilityMatrix: [],
      form: {},
      token: 'b171736f6456c679b8bb6ab64703f2', // '440011169da7176c513407605ed290'
      endpoint: 'https://jgast.co/forms', // 'http://localhost:3002'
      error: '',
      shouldScroll: false,
      height: {
        val: 0,
      },
      translate: {
        val: '',
      },
    }
  },

  watch: {
    action(val) {
      if (val === 'showNext') this.showNext()
      if (val === 'showPrev') this.showPrev()
      // this.checkForScroll()
      this.$store.commit('form/setAction', '')
      this.$store.commit('layout/actionScrollToTop')
    },
    current: {
      handler(val) {
        this.$store.commit('form/setCurrent', val)
      },
      immediate: true,
    },
    length: {
      handler(val) {
        this.$store.commit('form/setLength', val)
      },
      immediate: true,
    },
    // form: {
    //   deep: true,
    //   handler: _throttle(function () {
    //     this.checkForScroll()
    //   }, 250),
    // },
    // state() {
    //   this.checkForScroll()
    // },
  },

  computed: {
    action() {
      return this.$store.state.form.action
    },
    current() {
      return this.visibilityMatrix.indexOf(true)
    },
    length() {
      return this.page.content.steps.length
    },
    state() {
      return this.$store.state.form.state
    },
  },

  methods: {
    // checkForScroll: _debounce(async function () {
    //   await this.$nextTick()
    //   await this.$nextDOMUpdate()
    //   const component = this.$refs.step.find((i) =>
    //     i.$el.classList.contains('relative')
    //   )
    //   if (['loading', 'error', 'success'].includes(this.state)) {
    //     const el = this.$refs.step[0].$el
    //     this.height.val = el.clientHeight
    //   } else {
    //     const el = component.$el
    //     this.height.val = el.clientHeight
    //   }
    //   await this.$nextTick()
    //   await this.$nextDOMUpdate()
    //   this.$store.commit('layout/setShouldUpdateFrameScrollHeight')
    // }, 25),
    async validateStep(index) {
      return false
    },
    async showNext() {
      const index = this.current
      this.$store.commit('layout/actionScrollToTop')

      if (index === this.page.content.steps.length - 1) {
        this.submit()
      } else {
        this.$set(this.visibilityMatrix, index, false)
        this.$set(this.visibilityMatrix, index + 1, true)
        // console.log('SHOW NEXT', index + 1)
      }
    },
    showPrev() {
      const index = this.current
      this.$store.commit('layout/actionScrollToTop')

      if (index === 0) {
        // console.log('PREV FIRST STEP')
      } else {
        this.$set(this.visibilityMatrix, index, false)
        this.$set(this.visibilityMatrix, index - 1, true)
        // console.log('SHOW PREV', index - 1)
      }
    },
    isVisible(index) {
      return this.visibilityMatrix[index]
    },
    isNext(index) {
      return this.visibilityMatrix[index - 1]
    },
    validationHandler(index, boolean) {
      this.$store.commit('form/setValidation', [index, boolean])
    },

    async getSecret() {
      try {
        const res = await this.$axios({
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          url: `${this.endpoint}/api/secret/create?token=${this.token}`,
        })
        // console.log('SECRET', res.data.secret)
        return res.data.secret
      } catch (e) {
        this.handleError(e)
      }
    },
    async submit() {
      this.$store.commit('form/setState', 'loading')
      try {
        const secret = await this.getSecret()
        if (!secret) throw new Error('No Secret')
        // console.log(this.form)
        let images = null
        for (const step in this.form) {
          for (const module in this.form[step]) {
            if (module.includes('uploadImages')) {
              if (
                this.form[step][module] &&
                this.form[step][module].images &&
                this.form[step][module].images.length > 0
              ) {
                images = await this.submitImages(
                  this.form[step][module].images,
                  secret
                )
                // console.log('IMAGES', images, this.form[step][module].images)

                if (images.data.failed.length > 0)
                  throw new Error('Image Upload Failed')

                let imagePaths = []
                this.form[step][module].images.forEach((image) => {
                  const asset = images.data.assets.find(
                    (i) => i.title === image.name
                  )
                  // console.log('ASSET', asset)
                  imagePaths.push(
                    `${this.endpoint}/storage/uploads${asset.path}`
                  )
                })

                this.form[step][module].images = imagePaths
                // console.log('IMAGES PATHS', imagePaths)
              }
            }
          }
        }

        this.form.language = this.$i18n.locale

        await this.submitData(this.form, secret)
        this.$store.commit('form/setState', 'success')
        /*
         * Send to GA4 if applicable
         */
        if (window.dataLayer)
          window.dataLayer.push({
            event: 'form_success',
          })

        /*
         * Back
         */
        setTimeout(() => {
          this.$router.push(this.getParentPagePath())
        }, 5500)
      } catch (e) {
        this.handleError(e)
      }
    },
    async submitImages(images, secret) {
      let formData = new FormData()

      images.forEach((c) => {
        formData.append('files[]', c.raw)
      })

      const res = await this.$axios({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        url: `${this.endpoint}/api/images/save?token=${this.token}&secret=${secret}`,
        data: formData,
      })

      return res
    },
    async submitData(form, secret) {
      const res = await this.$axios({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        url: `${this.endpoint}/api/data/save?token=${this.token}&secret=${secret}`,
        data: {
          form: form,
        },
      })

      return res
    },
    handleError(e) {
      this.$store.commit('form/setState', 'error')
      this.error = 'Ein Fehler ist aufgetreten, bitte versuche es erneut.' // e
      // console.log('ERROR', e)
    },
  },

  mounted() {
    this.$store.commit('form/setState', 'mounted')
    this.visibilityMatrix = this.page.content.steps.map((i) => false)
    this.$set(this.visibilityMatrix, 0, true)
  },
}
